import { action, makeObservable, observable, runInAction } from 'mobx';
import { captureException } from '@sentry/react';
import SearchResult from '../model/SearchResult';
import AuthStore from './AuthStore';
import { searchUser } from '../api/admin';

class SearchStore {
  loading = false;

  results: SearchResult[] = [];

  authStore: AuthStore;

  constructor(authStore: AuthStore) {
    this.authStore = authStore;

    makeObservable(this, {
      loading: observable,
      results: observable,
      search: action,
    });
  }

  async search(query: string): Promise<void> {
    this.loading = true;

    const cleanQuery = query.trim();

    if (cleanQuery.length > 0) {
      const results = await searchUser(cleanQuery).catch((error) => {
        captureException(error);
      });

      if (results) {
        runInAction(() => {
          this.results = results;
        });
      } else {
        runInAction(() => {
          this.results = [];
        });
      }
    }

    runInAction(() => {
      this.loading = false;
    });
  }
}

export default SearchStore;
